export default {
  methods: {
    $_change() {
      let componentName = this.$options.name;

      if (!this.result) {
        this.$emit('input', '', this.index);
        return;
      }

      if (componentName == 'YhcDatePicker') {
        let currData;
        if (this.isStartDate) {
          currData = +new Date(+this.result).setHours(0, 0, 0, 0);
        } else {
          currData = +new Date(+this.result).setHours(0, 0, 0, 0) + 86400000 - 1;
        }
        this.$emit('input', currData, this.index);
      } else {
        this.$emit('input', +new Date(+this.result), this.index);
      }
    },
  },
};
